import { render, staticRenderFns } from "./QuickCreate.vue?vue&type=template&id=8a3f147c&scoped=true"
import script from "./QuickCreate.vue?vue&type=script&lang=js"
export * from "./QuickCreate.vue?vue&type=script&lang=js"
import style0 from "./QuickCreate.vue?vue&type=style&index=0&id=8a3f147c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3f147c",
  null
  
)

export default component.exports